import type {ApiLimit} from 'src/openapi/admin/models/ApiLimit';

export const buildUniqueId = ({limitType, period, quantity}: ApiLimit) => {
    return [limitType, period, quantity].join('-');
};
